import { render, staticRenderFns } from "./LucideIcon.vue?vue&type=template&id=5cbfefa6&scoped=true"
import script from "./LucideIcon.vue?vue&type=script&lang=js"
export * from "./LucideIcon.vue?vue&type=script&lang=js"
import style0 from "./LucideIcon.vue?vue&type=style&index=0&id=5cbfefa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node-subscribe/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbfefa6",
  null
  
)

export default component.exports